// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EmailSendEmailSingle } from './emailSendEmailSingle.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SendRequestModel {
    'email': EmailSendEmailSingle | null;
    'check': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SendRequestModel>> = [
        {
            "name":     "email",
            "baseName": "email",
            "type":     "EmailSendEmailSingle"
        },
        {
            "name":     "check",
            "baseName": "check",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return SendRequestModel.attributeTypeMap;
    }
}
